"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.printFormatDimensions = exports.formatNames = exports.resolutions = exports.PrintFormat = void 0;
var PrintFormat;
(function (PrintFormat) {
    PrintFormat[PrintFormat["a0"] = 0] = "a0";
    PrintFormat[PrintFormat["a1"] = 1] = "a1";
    PrintFormat[PrintFormat["a2"] = 2] = "a2";
    PrintFormat[PrintFormat["a3"] = 3] = "a3";
    PrintFormat[PrintFormat["a4"] = 4] = "a4";
    PrintFormat[PrintFormat["a5"] = 5] = "a5";
})(PrintFormat = exports.PrintFormat || (exports.PrintFormat = {}));
exports.resolutions = [72, 150, 300];
exports.formatNames = {
    [PrintFormat.a0]: 'A0',
    [PrintFormat.a1]: 'A1',
    [PrintFormat.a2]: 'A2',
    [PrintFormat.a3]: 'A3',
    [PrintFormat.a4]: 'A4',
    [PrintFormat.a5]: 'A5',
};
exports.printFormatDimensions = {
    [PrintFormat.a0]: [1189, 841],
    [PrintFormat.a1]: [841, 594],
    [PrintFormat.a2]: [594, 420],
    [PrintFormat.a3]: [420, 297],
    [PrintFormat.a4]: [297, 210],
    [PrintFormat.a5]: [210, 148],
};
//# sourceMappingURL=formats.js.map